module.exports = __webpack_public_path__ + "img/chevron-solid.8a6a9149.svg";